import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';

const AddressInput = lazy(() => import(/* webpackChunkName: "AddressInput" */ './components/AddressInput'));

const wrapInput = (input) => {
    const wrapper = document.createElement('div');
    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(input);

    return wrapper;
};

const addressZipCodeInputs = Array.from(document.querySelectorAll('.address-input-zip-code'));
addressZipCodeInputs.forEach((element, index) => {
    let houseNumberInput = null;
    let streetInput = null;
    let cityInput = null;

    const props = {};
    for (const key in element.dataset) {
        props[key] = element.dataset[key];

        try {
            props[key] = JSON.parse(props[key]);
        } catch (e) { } // eslint-disable-line no-empty
    }

    Array.from(document.querySelectorAll('.address-input-house-number')).forEach((houseNumberInputElement, houseNumberInputIndex) => {
        if (index === houseNumberInputIndex) {
            wrapInput(houseNumberInputElement);
            houseNumberInput = houseNumberInputElement;
        }
    });

    Array.from(document.querySelectorAll('.address-input-street')).forEach((streetInputElement, streetInputIndex) => {
        if (index === streetInputIndex) {
            wrapInput(streetInputElement);
            streetInput = streetInputElement;
        }
    });

    Array.from(document.querySelectorAll('.address-input-city')).forEach((cityInputElement, cityInputIndex) => {
        if (index === cityInputIndex) {
            wrapInput(cityInputElement);
            cityInput = cityInputElement;
        }
    });

    render(
        <Suspense fallback={<></>}>
            <AddressInput
                houseNumberInputDomNode={houseNumberInput}
                streetInputDomNode={streetInput}
                cityInputDomNode={cityInput}
                className={element.className}
                id={element.id}
                name={element.name}
                value={element.value}
                required={element.required}
                {...props}
            />
        </Suspense>,
        wrapInput(element)
    );
});
